import React, { useContext, useState, useEffect } from "react";
import { UserPreferencesContext } from "../../../../../utilities/contexts";
import EChartsReact from "echarts-for-react";
import ECLLoader from "../../../../Widgets/ECLLoader/ECLLoader";
import { translate } from "../../../../../utilities/Translate";
import { endpointRequest } from "../../../../../utilities/requests";
import fromHTML from "../../../../../utilities/fromHTML";

export default function ExplorerHeatmap(props) {
   const [heatmapData, setHeatmapData] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   const userPrefs = useContext(UserPreferencesContext);
   const userTheme = userPrefs.theme;
   const background = userTheme !== "Dark" ? "#E6E6E6" : "#171717";
   const text = userTheme === "Dark" ? "white" : "black";

   useEffect(() => {
      const rootId = props.headlist.at(-1);
      const sessionId = props.flatDoc[rootId].session;
      endpointRequest(
         props.parentObject,
         props.block.id,
         sessionId,
         "Correlation Matrix",
      )
         .then((res) => {
            const xValues = res.rows.map((r) => r[1]);
            const xCategories = [...new Set(xValues)];
            const yValues = res.rows.map((r) => r[2]);
            const yCategories = [...new Set(yValues)];

            setHeatmapData({
               data: res.rows.map((r) => {
                  return {
                     value: [r[1], r[2], r[0]],
                     itemStyle: {
                        color: r[3],
                     },
                  };
               }),
               xCategories: xCategories,
               yCategories: yCategories,
            });
            setLoading(false);
         })
         .catch((error) => {
            console.error(error);
            setError(translate("Error Loading Heatmap"));
         });
   }, [props.block.react.refresh]);

   if (loading || error || !heatmapData) {
      return <ECLLoader message={error} />;
   }

   const heater = {
      series: [
         {
            type: "heatmap",
            name: "Correlation",
            symbol: "path://M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z",
            data: heatmapData.data,
            label: {
               show: true,
               formatter: function (params) {
                  return params.data.value[2]; // This line sets the label text to the correlation value
               },
               color: "#000", // This line sets the label color to black
            },
            tooltip: {
               trigger: "item",
               backgroundColor: background,
               textStyle: {
                  color: text,
               },
               formatter: function (params) {
                  //Create these base divs ahead of time
                  const tooltipContainer = document.createElement("div");
                  tooltipContainer.setAttribute("class", "tooltip-container");

                  const tooltipHeader = document.createElement("div");
                  tooltipHeader.setAttribute("class", "tooltip-header");
                  tooltipContainer.append(tooltipHeader);

                  const tooltipBody = document.createElement("div");
                  tooltipBody.setAttribute("class", "tooltip-body");
                  tooltipContainer.append(tooltipBody);
                  tooltipHeader.append(
                     fromHTML(
                        `<span class="big-boy-marker" style="background-color:${params.color}"></span>`,
                     ),
                  );
                  tooltipBody.append(
                     fromHTML(
                        `<div class="tooltip-row"><p class="tooltip-value">${params.data.value[0]}</p><p class="tooltip-value">${params.data.value[1]}</p></div>`,
                     ),
                  );
                  tooltipBody.append(
                     fromHTML(
                        `<div class="tooltip-row"><p>Correlation</p></div>`,
                     ),
                  );
                  tooltipBody.append(
                     fromHTML(
                        `<div class="tooltip-row"><p class="tooltip-single-value">${params.data.value[2]}</p></div>`,
                     ),
                  );
                  return tooltipContainer;
               },
            },
         },
      ],
      tooltip: {
         trigger: "grid",
      },
      grid: [
         {
            backgroundColor: background,
            show: true,
         },
      ],
      xAxis: [
         {
            position: "bottom",
            type: "category",
            nameTextStyle: {
               color: text,
            },
            axisLine: {
               lineStyle: {
                  color: text,
               },
            },
            splitLine: {
               lineStyle: {
                  color: ["#C4C4C4", "#B6B8B9"],
               },
            },
            alignTicks: true,
            axisTick: {
               alignWithLabel: true,
               show: true,
            },
            hideOverlap: true,
            axisLabel: {
               hideOverlap: true,
               width: "",
               overflow: "none",
               interval: 0,
            },
            data: heatmapData.xCategories,
            gridIndex: 0,
         },
      ],
      yAxis: [
         {
            position: "left",
            type: "category",
            nameTextStyle: {
               color: text,
            },
            axisLine: {
               lineStyle: {
                  color: text,
               },
            },
            splitLine: {
               lineStyle: {
                  color: ["#C4C4C4", "#B6B8B9"],
               },
            },
            alignTicks: true,
            axisTick: {
               alignWithLabel: true,
               show: true,
            },
            hideOverlap: true,
            axisLabel: {
               hideOverlap: true,
               width: 60,
               overflow: "truncate",
            },
            inverse: true,
            data: heatmapData.yCategories,
            gridIndex: 0,
         },
      ],
      legend: false,
      textStyle: {
         color: text,
      },
      backgroundColor: background,
      visualMap: [
         {
            type: "continuous",
            min: 0,
            max: 10,
            seriesIndex: [0, 0],
            show: false,
         },
      ],
   };

   return (
      <div id={props.id}>
         <EChartsReact option={heater} />
      </div>
   );
}
